import { createSlice } from '@reduxjs/toolkit';

type DialogInitialValues = {
    isOpen: boolean
    type: string
    defaultForm?: string
    status?: string
    id?: number | null
    payload?: any
    title?: string
    onboardDetails?: any
    OfferDetails?: any
    clockInDate?: string
    clockOutDate?: string
}

const initialState: DialogInitialValues = {
    isOpen: false, type: '', status: '', defaultForm: '', id: null, payload: null, onboardDetails: null, OfferDetails: null,clockInDate: '',clockOutDate: ''
};

const clockSlice = createSlice({
    name: 'dialog',
    initialState,
    reducers: {
        openDialog: (state, action) => {
            return { ...state, isOpen: true, ...action.payload }
        },
    },
});

export const { openDialog } = clockSlice.actions;

export default clockSlice.reducer;
